import { post, postParams, getJsonp } from './http';
import * as constants from './constant';

// 查询楼层信息
export const queryFloor = (value = {}) => {
    return post(constants.MAIN_PAGE_DATA + JSON.stringify(value));
}


// 查询公共头尾和菜单

export const getCommonData = (params = {}, config = {}) => {
    return postParams(constants.COMMON_JDW_REQUEST_URL, params, config)
}

// PC搜索页

export const handleProductSearch = (params = {}, config = {}) => {
    return postParams(constants.COMMON_JDW_REQUEST_URL, params, config)
}

export const queryRecommends = (params, config = {}) => {
    // return getJsonp(constants.QUERY_RECOMMEND, "lid=1&lim=" + params.lim + "&ec=utf-8&uuid=&pin=" + params.pin + "&c1=&c2=&c3=&sku=&hi=brand:,price:,keyword:" + params.keyword + "&p=619010", 'jsonpCallBack')
    return postParams(constants.COMMON_JDW_REQUEST_URL, params, config)
}

export const queryAdvertisement = (params) => {
    return getJsonp(constants.QUERY_ADVERTISEMENT, params)
}

export const queryPrdPrice = (params = {}, config = {}) => {
    return postParams(constants.COMMON_JDW_REQUEST_URL, params, config)
}

export const queryShopChat = (params) => {
    return getJsonp(constants.CKECK_CHAT, params)
}

export const getCommentCountBySkuId = (params = {}) => {
    const _params = {
        functionId: 'getCommentCountBySkuId',
        appid: 'jdw_pc',
        client: 'pc',
        body: params
    }
    return postParams(constants.COMMON_JDW_REQUEST_URL, _params, { isSigned: true })
}

export const getComparedInfo = (params) => {
    return getJsonp(constants.COMPAREDINFO, params)
}

export const productFollow = (params) => {
    return postParams(constants.COMMON_JDW_REQUEST_URL, params)
}

export const productIsFollow = (params = {}) => {
    return postParams(constants.COMMON_JDW_REQUEST_URL, params)
}

